<template>
  <span
    v-bind:key="slotData.name"
    :class="{
      'green--text': item.type === 'revenue'
    }"
  >
    <template v-if="item.type === 'revenue'"
      >-</template
    >
    {{ $number(item[slotData.name]) }}
  </span>
</template>

<script>
export default {
  name: "AmountItem",
  props: {
    slotData: {
      type: Object
    },
    item: {
      type: Object
    }
  }
};
</script>

<style scoped></style>
